module.exports = __webpack_public_path__ + "static/media/editicon.42d03af6.svg";